import { Reveal, Eyebrow, SectionTitle } from "./shared";
import { useSite } from "../../context/SiteContext";

export default function Process() {
  const { content } = useSite();
  const steps = content?.process || [];
  if (!steps.length) return null;

  return (
    <section id="como-funciona" className="py-20 lg:py-28 bg-sand" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow>O caminho até o grande dia</Eyebrow>
          <SectionTitle>Como funciona</SectionTitle>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {steps.map((s, i) => (
            <Reveal key={i} delay={i * 0.12}>
              <div className="relative pl-0 lg:pt-14" data-testid={`process-step-${i}`}>
                <div className="hidden lg:block absolute top-6 left-0 right-0 h-px bg-gold/30" />
                <span className="hidden lg:flex absolute top-0 left-0 w-12 h-12 rounded-full bg-olive text-cream items-center justify-center font-serif text-lg border-4 border-sand">
                  {i + 1}
                </span>
                <span className="lg:hidden font-serif text-5xl text-gold/60">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="mt-3 text-xl sm:text-2xl font-serif text-ink">{s.title}</h3>
                <p className="mt-3 text-sm sm:text-base font-light text-cocoa leading-relaxed">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
